<template>
  <div v-show="active === ruleForm.status">
    <el-dialog title="ToutBox" :visible.sync="dialog.toutbox">
      <el-form :model="ruleForm">
        <el-form-item label="API Key">
          <el-input v-model="ruleForm.configuration.user" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" v-if="ruleForm.id" @click="remove()">Desativar integração</el-button>
        <el-button @click="dialog.toutbox = false">Cancelar</el-button>
        <el-button type="primary" @click="save()">Salvar</el-button>
      </span>
    </el-dialog>
    <IntegrationCard image="/img/integration/logo-toutbox-login.png" title="ToutBox"
      :status="ruleForm.status" :updatedAt="ruleForm.updatedAt" :options="ruleForm.options" :id="ruleForm.id"
      @configure="dialog.toutbox = true" />

  </div>
</template>
<script>
import { i18n } from "@/plugin/i18n";
import { IntegrationService } from "@/services/customers/integration.services";
import IntegrationCard from "../components/IntegrationCard.vue";

export default {
  name: "Integration",
  props: ["customer", "active"],
  methods: {
    setConfig(config) {
      const vm = this;
      vm.ruleForm = config;
    },
    reset() {
      const vm = this;
      vm.ruleForm = {
        status: false,
        options: [],
        configuration: {
          user: "",
          password: "",
        },
        updatedAt: "Sem registros"
      };
    },
    execute() {
      const vm = this;
      this.$confirm("Esse opção irá enviar para a integração todos os registros de clientes e objetos. Deseja continuar?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        const loading = vm.$loading(vm.$options.loading);
        IntegrationService.execute(vm.ruleForm.id)
          .then((response) => {
            setTimeout(() => {
              vm.$emit("refresh");
            }, 300);
            this.$message({
              type: "success",
              message: "Replicação executado com sucesso!"
            });
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => loading.close());
      }).catch((err) => {
        this.$message({
          type: "info",
          message: "Delete canceled"
        });
      });
    },
    save() {
      var vm = this;
      const loading = vm.$loading(vm.$options.loading);
      if (vm.ruleForm.id) {
        IntegrationService.update(vm.ruleForm.id, { type: "1", configuration: vm.ruleForm.configuration, customer: vm.customer })
          .then((response) => {
            setTimeout(() => {
              vm.$emit("refresh");
            }, 300);
            vm.dialog.toutbox = false;
            this.$message({
              type: "success",
              message: i18n.tc("integracao-adicionado-sucesso"),
            });
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => loading.close());
      }
      else {
        IntegrationService.add({ type: "1", configuration: vm.ruleForm.configuration, customer: vm.customer })
          .then((response) => {
            setTimeout(() => {
              vm.$emit("refresh");
            }, 300);
            vm.dialog.toutbox = false;
            this.$message({
              type: "success",
              message: i18n.tc("integracao-adicionado-sucesso"),
            });
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => loading.close());
      }
    },
    logs: function () {
      const vm = this;
      this.$router.push({
        name: "integration.logs",
        params: { id: vm.ruleForm.id },
      });
    },
    remove: function (id, name) {
      const vm = this;
      this.$confirm(i18n.t("confirmar-eliminacao-integracao", { id: vm.ruleForm.type === "1" ? "ToutBox" : "Outra" }), i18n.tc("aviso"), {
        confirmButtonText: "OK",
        cancelButtonText: i18n.tc("cancelar"),
        type: i18n.tc("aviso"),
        center: true,
      }).then(() => {
        const loading = vm.$loading(vm.$options.loading);
        IntegrationService.delete(vm.ruleForm.id)
          .then((response) => {
            setTimeout(() => {
              vm.$emit("refresh");
              vm.dialog.toutbox = false;
            }, 300);
            this.$message({
              type: "success",
              message: i18n.tc("integracao-eliminado-sucesso"),
            });
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => loading.close());
      });
    },
  },
  data() {
    return {
      ruleForm: {
        id: "",
        status: false,
        options: [],
        configuration: {
          user: "",
          password: "",
        },
        updatedAt: "Sem registros"
      },
      dialog: {
        toutbox: false,
      }
    };
  },
  components: { IntegrationCard }
};
</script>
<style>
.right {
  float: right;
}

.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.integration-image {
  padding: 5px;
}

.w-33 {
  width: 33%;
}

.w-50 {
  width: 50%;
}
</style>